import React from 'react';

export const Overlays = {
    SEARCH: 'search',
    SEARCH_LOGS: 'search_logs',
    USER_DROPDOWN: 'user_dropdown',
    STAT_FILTER: 'stat_filter',
    LICENSE_INFORMATION: 'license_information',
};

const OverlayContext = React.createContext({});
export default OverlayContext;
